export enum RegistrationGaCategory {
  MultiPlanRegistrationPages = 'new-repo-registration-pages',
  Pages = 'registration-pages',
}
